import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import commonActions from "../../Redux/common/actions";
import { Dialog, DialogContent, Grid, IconButton } from "@mui/material";
import { IoMdCloseCircleOutline } from "react-icons/io";
import useFetchCandidateTokenDetails from "../../hooks/useFetchCandidateTokenDetails";
import { auditLog } from "../../utils/auditLog";

export default function ToolBarModal({}) {
  // Derieved variables
  const dispatch = useDispatch();
  const { heartBeat } = useSelector((state) => state.examReducer);
  const { showModal } = useSelector((state) => state.commonReducer);
  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  useFetchCandidateTokenDetails({ setCandidateTokenDetails });
  // Helper functions
  const handleClose = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: false, type: null, method: "T", data: null },
    });
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: `User Closed Tool Bar Popup in Live Test`,
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
  };

  return (
    <>
      <Dialog
        open={showModal?.show && showModal?.method === "T"}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding: "8px",
            backgroundColor: "rgba(240, 240, 251, 1)",
          },
        }}
      >
        <DialogContent
          sx={{
            width: "100%",
            backgroundColor: "rgba(240, 240, 251, 1)",
            overflowY: "scroll",
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(63, 65, 209, 1)",
            },
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 0,
              right: 4,
              color: "#000",
            }}
          >
            <IoMdCloseCircleOutline />
          </IconButton>
          <Grid
            p={2}
            sx={{
              minHeight: "350px",
              width: "100%",
            }}
          >
            <div style={{ position: "relative" }}>
              <embed
                src={`${showModal?.data}#toolbar=1&download=0&print=1&zoom=1`}
                type="application/pdf"
                width="100%"
                height="500px"
                style={{
                  border: "none",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: "0",
                  right: "55px",
                  width: "140px",
                  height: "40px",
                  backgroundColor: "rgb(60, 60, 60)",
                  zIndex: 1000,
                }}
              />
                  
            </div>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}
